import React, {Component} from 'react';
import { Link } from 'react-router-dom'
import './NavbarDropdown.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';


export default class NavbarDropdown extends Component {
	constructor(props) {
		super(props);
		this.handleMouseHover = this.handleMouseHover.bind(this);
		this.state = {
      		isHovering: false,
			headerTitle: this.props.title,
		};
	}

  handleMouseHover() {
    this.setState(this.toggleHoverState);
  }

  toggleHoverState(state) {
    return {
      isHovering: !state.isHovering,
    };
  }

	render() {
		return (
			<div onMouseEnter={this.handleMouseHover} onMouseLeave={this.handleMouseHover}>
				<div className="navbar_dropdown_header">
					<div className="navbar_dropdown_header_title">{this.props.headerTitle}</div>
					<div className="navbar_dropdown_header_icon">
					{this.state.isHovering ? <FontAwesomeIcon icon={faAngleUp} /> : <FontAwesomeIcon icon={faAngleDown} />}
					</div>
					<div className="navbar_dropdown_list_container">
						<ReactCSSTransitionGroup
		                transitionName="slide"
		                transitionEnterTimeout={300}
		                transitionLeaveTimeout={0.1}>
							{this.state.isHovering && <ul className="navbar_dropdown_list">
								<hr/>
								{this.props.data.map(item => (
									<Link to={item.childLink} >
										<li className="navbar_dropdown_list_item" key={item}>
											{item.childTitle}
										</li>
									</Link>
								))}
							</ul>}
						</ReactCSSTransitionGroup>
					</div>
				</div>

			</div>
		)
	}
};
